import { differenceInMilliseconds } from "date-fns";



export const calculateMilliSecondsFromLastTime = (lastDateTime: Date): number => {
  const remainingInterval = Math.abs(differenceInMilliseconds(new Date(), lastDateTime))
  return remainingInterval;
}


export const getRemainingTime = () => {
  let hcpIdleTime: number = 0;
  let manIdleTime: number = 0;
  
  const momentTimeLogged = localStorage.getItem("momentTimeLogged") || "";
  if (momentTimeLogged) {
    // when user continues it's older session
    const remainingInterval = calculateMilliSecondsFromLastTime(new Date(momentTimeLogged))

    const configHcpIdleTime = 1000 * 60 * Number(process.env.REACT_APP_HCP_SESSION_IN_MINUTES || 1);
    hcpIdleTime = remainingInterval > 0 ? configHcpIdleTime - remainingInterval : configHcpIdleTime;

    const configManIdleTime = 1000 * 60 * Number(process.env.REACT_APP_MANUFACTURER_SESSION_IN_MINUTES || 1)
    manIdleTime = remainingInterval > 0 ? configManIdleTime - remainingInterval : configManIdleTime;
  } else {
    // When user logged in first time
    hcpIdleTime = 1000 * 60 * Number(process.env.REACT_APP_HCP_SESSION_IN_MINUTES || 1)
    manIdleTime = 1000 * 60 * Number(process.env.REACT_APP_MANUFACTURER_SESSION_IN_MINUTES || 1)
  }

  return { hcpIdleTime, manIdleTime };
}


export const formatTime = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return [hours, minutes, seconds]
    .map((val) => String(val).padStart(2, '0'))
    .join(':')
}
